import gql from 'graphql-tag';

export const activateOrderMutation = gql`
  mutation activateOrder($input: ActivateOrderInput!) {
    activateOrder(input: $input) {
      Status
    }
  }
`;
